import { useAppDispatch } from '@shared/hooks';

import { openOutModal } from '@src/library/redux/modal';

export const useLogout = () => {
	const dispatch = useAppDispatch();

	const logout = () => dispatch(openOutModal());

	return {
		logout,
	};
};
